/**
 * Testimonials List - Add new testimonials here
 *
 * Nummerierung automatisch durch Array-Position (0, 1, 2, 3...)
 * Reihenfolge ändern = Eintrag im Array verschieben
 *
 * To add a new testimonial, copy this block and paste before the closing bracket:
 * {
 *   name: "Max M.",
 *   context: "Berater, Schweiz",
 *   quote: "Das war eine unglaubliche Erfahrung...",
 *   image: "https://media.thelightcall.com/client-portraits/max.jpg",
 * }
 */

export const TESTIMONIALS_LIST = [
  {
    name: "Anna K.",
    context: "Health Coach, Deutschland",
    quote: "Durch Benjamins Ruhe und Klarheit konnte ich mich trotz anfänglicher starker Aufregung schnell auf die Session einlassen. Es ist, als würde er durch dich durchsehen und dich sofort an die Orte führen, die dir vorher nie bekannt waren – aber genau die sind, die du brauchst. Es war unbeschreiblich, an einem Ort purer Liebe jenseits von Materie zu sein, meine Engel zu treffen und an diesem Ort des absoluten Friedens zu verweilen, zu dem ich jetzt auch im Alltag immer wieder zurückkehren kann. Besonders wertvoll war für mich die Integration danach, die mir geholfen hat, die Erkenntnisse wirklich in mir zu verankern. Ich fühle mich geführt und getragen. Vielen Dank dafür.",
    image: "https://media.thelightcall.com/client-portraits/Anna-krickel.jpg",
  },
  {
    name: "Alexander W.",
    context: "Musikproduzent, USA",
    quote: "Alles, was Benjamin mit uns gemacht hat, ging mit Leichtigkeit. Ich bin sehr schnell in den Kontakt mit mir selbst und den anderen gekommen. Benjamin hat ganz klar den Raum für Offenheit, Lernen und Freude geschaffen.",
    image: "https://media.thelightcall.com/client-portraits/alex%20w%202.jpg",
  },
  {
    name: "Arthur K.",
    context: "Fotograf, Deutschland",
    quote: "Ich habe gelacht, ich habe geweint, ich war wieder in meiner Kindheit, ich war überall. Durch Benjamins Coaching-Begleitung konnte ich tief in meine Emotionen eintauchen.",
    image: "https://media.thelightcall.com/client-portraits/arthur.jpg",
  },
  {
    name: "Hernan D.",
    context: "Lifeguard, Argentinien",
    quote: "Ich wollte dir sagen, dass ich mich sehr glücklich fühle – dank der Lehren und Werkzeuge, die ich während des Retreats bekommen habe. Sie helfen mir enorm, in meiner Mitte zu bleiben und alles harmonisch fließen zu lassen.",
    image: "https://media.thelightcall.com/client-portraits/hernan.jpg",
  },
]

/**
 * Carousel Configuration
 * User-editable settings for the TestimonialCarousel component
 */
export const CAROUSEL_CONFIG = {
  swipeHint: "← Swipe für mehr →",
}
